<template>
  <div class="d-flex justify-center align-center h-100">
    <v-card class="pa-6" elevation="3" max-width="400">
      <v-card-text class="text-center">
        <v-progress-circular 
          indeterminate 
          color="primary" 
          size="64"
          class="mb-4"
        ></v-progress-circular>
        <h3 class="mb-2">Logging out...</h3>
        <p class="text-body-2">Please wait while we complete your logout.</p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import authService from '@/services/auth';
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'LogoutCallback',
  async created() {
    try {
      const authStore = useAuthStore();
      
      // Check if we came from Okta logout callback
      const fromOktaLogoutCallback = sessionStorage.getItem('fromOktaLogoutCallback');
      sessionStorage.removeItem('fromOktaLogoutCallback');
      
      // Clear RISE session data
      sessionStorage.setItem("accessToken", "");
      authStore.userAuthorized = false;
      
      // Clear any remaining Okta tokens
      try {
        await authService.oktaAuth.tokenManager.clear();
      } catch (oktaError) {
        console.warn('Error clearing Okta tokens:', oktaError);
      }
      
      // Redirect to login page
      setTimeout(() => {
        this.$router.push({ name: 'login' });
      }, 1000);
      
    } catch (error) {
      console.error('Logout callback error:', error);
      // Still redirect to login even if there's an error
      this.$router.push({ name: 'login' });
    }
  }
};
</script>

<style scoped>
.h-100 {
  height: 100vh;
}
</style>